// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Link_link__ljtxq{
    color: #40798C;
    font-family: 'Gotham Medium', serif;
    font-size: 16px;
    text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Link.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,mCAAmC;IACnC,eAAe;IACf,qBAAqB;AACzB","sourcesContent":[".link{\n    color: #40798C;\n    font-family: 'Gotham Medium', serif;\n    font-size: 16px;\n    text-decoration: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `Link_link__ljtxq`
};
export default ___CSS_LOADER_EXPORT___;
